import { Box, Paper, Typography } from '@mui/material';
import React from 'react';

type Props = {
	title: string;
	children: JSX.Element | null;
	// eslint-disable-next-line react/require-default-props
	disablePadding?: boolean;
};

export default ({ children, title, disablePadding }: Props) => (
	<Box marginY={3} overflow="hidden">
		<Typography display="inline-block" marginY={3} variant="overline">
			{title}
		</Typography>
		<Paper
			sx={{
				borderRadius: 1,
				padding: disablePadding ? 0 : 2,
				boxShadow: 1,
				width: '100%'
			}}
		>
			{children}
		</Paper>
	</Box>
);
